<h1 mat-dialog-title> {{ isNew ? 'Nouveau contrat' : 'Editer contrat' }} </h1>
<div mat-dialog-content>
  <!--
  {{ data | json}}
  <br />
  {{ contract | json}} -->

  <form #contractForm="ngForm" class="contract-form">
    <h6>ID : <b> {{ contract.contractId }}</b></h6>
    <mat-form-field>
      <mat-label>Type de contrat</mat-label>
      <mat-select required name="type" [(ngModel)]="contract.type">
        @for (serv of contractTypes; track serv) {
          <mat-option [value]="serv.code" >{{serv.desc}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label >Titre</mat-label>
      <input required matInput type="text" matNativeControl  name ="title" placeholder="Titre"  [(ngModel)]="contract.title" >
    </mat-form-field>

    <mat-form-field >
      <mat-label >Description</mat-label>
      <textarea required matInput type="text"  name ="description" placeholder=""  [(ngModel)]="contract.description" ></textarea>
    </mat-form-field>
    <!--
    <mat-form-field >
      <mat-label>Date Activité </mat-label>
      <input matInput [matDatepicker]="picker" name="contractDate" [(ngModel)]="contract.scheduledDate">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field> -->

  </form>
</div>

<div mat-dialog-actions>
  <button class="simple-button" mat-button [mat-dialog-close]="">Annuler</button>
  <button class="simple-button" [disabled] = !contractForm.valid mat-button [mat-dialog-close]="contract" (click)="submitContract();$event.stopPropagation()"> Soumettre </button>
</div>